import * as loaders from './loaders'
import * as plugins from './plugins'
import * as configs from './configs'
import * as compiler from './compiler.helpers'
export = {
  loaders,
  plugins,
  configs,
  compiler,
}
